import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../services/app.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {

  private nombreCache : string | null = null;

  constructor(public appService : AppService,
              private router : Router) {}

  /**
   * En mobile el prototipo pone un boton de volver en el header, visible solo
   * cuando no estas en el Resumen. En desktop no hace falta: la sidebar siempre
   * muestra donde estas y como salir.
   */
  get mostrarVolver() : boolean {
    return this.router.url !== '/home';
  }

  volver() {
    history.back();
  }

  /**
   * El nombre no esta disponible cuando se crea el topbar: la home lo carga de
   * forma asincronica. Se reintenta la lectura hasta encontrarlo y despues se
   * cachea, para no leer sessionStorage en cada ciclo de deteccion de cambios.
   */
  get nombre() : string {

    if(this.nombreCache) return this.nombreCache;

    if(this.appService.idUnico){
      const datos = this.appService.getClienteAppDataSession(this.appService.idUnico);

      if(datos?.nombreCompletoPrincipal)
        this.nombreCache = datos.nombreCompletoPrincipal;
    }

    return this.nombreCache ?? '';
  }

  /** Iniciales para el avatar: primeras letras de los dos primeros tokens. */
  get iniciales() : string {

    const partes = this.nombre.trim().split(/\s+/).filter(p => p.length > 0);

    if(partes.length === 0) return '';

    return partes.slice(0, 2).map(p => p[0].toUpperCase()).join('');
  }

  // Links externos del topnav. Salen del prototipo, donde cada uno abre un modal
  // que dice "sale a puppis.com.ar" / "sale a la landing del Club".
  get enlaces() {
    const co = this.appService.countryCode === 'CO';
    const base = co ? 'https://www.puppis.com.co' : 'https://www.puppis.com.ar';

    return [
      { texto: 'Tienda',      url: base },
      { texto: 'Sucursales',  url: `${base}/sucursales` },
      { texto: 'Veterinaria', url: `${base}/veterinaria` },
      { texto: 'Puppis Club', url: `${base}/puppis-club` }
    ];
  }
}
